import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import ReactPlayer from "react-player";
import { Typography } from "@mui/material";
import { identify } from "mixpanel-browser";
export default function YouTubeComponent({ meta, isMobile = false }) {
  let width = "480px";
  let height = "360px";
  if (isMobile) {
    width = "270px";
    height = "202.5px";
  }
  const [isSongPlaying, setIsSongPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  function youtube_parser(url) {
    var regExp =
      // /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    var match = url.match(regExp);
    let id = match && match[1].length == 11 ? match[1] : false;
    return { id, url };
  }

  var youtubeurl = youtube_parser(meta.url).url;

  var id = youtube_parser(meta.url).id;
  // console.log("Print short youtubeurl", youtubeurl, id);

  var r = `<iframe  id="yFrame" class="yt-video" width="480px" height="360px"  src="https://www.youtube.com/embed/${id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  var rMobile = `<iframe  id="yFrame"  width="240px" height="180px" class="yt-video"  src="https://www.youtube.com/embed/${id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  var yFrame = `<iframe  id="yFrame" class="yt-video" src="https://www.youtube.com/embed/${id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

  const getMessageSubstr = (msg) => {
    if (typeof msg != "undefined") {
      if (isMobile) {
        let len = 30;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      } else {
        let len = 110;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      }
    } else return msg;
  };

  return (
    <>
      {isSongPlaying || isLoaded ? (
        <>
          <Typography sx={{ fontSize: "16px !important", lineHeight: "24px" }}>
            {isMobile ? getMessageSubstr(meta?.title) : meta?.title}
          </Typography>
          <Box sx={{ height: "5px" }}></Box>
          <ReactPlayer
            onProgress={(progress) => {
              // setPlayedSeconds(progress?.playedSeconds);
            }}
            onReady={() => {
              setIsLoaded(true);
            }}
            width={width}
            height={height}
            controls
            oonReady={() => {
              setIsLoaded(true);
            }}
            // url={[youtubeurl]}
            url={[`https://www.youtube.com/embed/${id}`]}
            playing={isSongPlaying}
            onPause={() => {
              setIsSongPlaying(false);
            }}
            onPlay={() => {
              setIsSongPlaying(true);
            }}
          />
        </>
      ) : (
        <Box style={{ position: "relative" }}>
          <Typography sx={{ fontSize: "16px !important", lineHeight: "24px" }}>
            {isMobile ? getMessageSubstr(meta?.title) : meta?.title}
          </Typography>
          <div
            style={{
              width: width,
              height: height,
              background: `url(https://img.youtube.com/vi/${id}/hqdefault.jpg)`,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              marginTop: "5px",
              backgroundSize: "contain",
            }}
          >
            <Box
              component="img"
              src={"/images/hitpredict/video.svg"}
              alt="hitpredict video img"
              sx={{
                cursor: "pointer",
                position: "relative",
                marignTop: "200px",
                width: isMobile ? "75px" : "100px",
                height: isMobile ? "45px" : "60px",
                borderRadius: "0px !important",
                background: "rgba(0,0,0,0.3)",
                padding: "10px",
                borderRadius: "15px",
              }}
              onClick={() => {
                setIsSongPlaying(true);
              }}
            />
          </div>
        </Box>
      )}
    </>
  );
}
